
import { saveAs } from 'file-saver';

export class BaseExportService {
  // Helper method for generating filenames
  protected generateFilename(data: any, extension: string): string {
    const baseName = data.title ? 
      data.title.toLowerCase().replace(/\s+/g, '-') : 
      'exported-data';
    
    const timestamp = new Date().toISOString().split('T')[0];
    return `${baseName}-${timestamp}.${extension}`;
  }
  
  // Helper method for downloading blobs
  protected downloadBlob(blob: Blob, filename: string): void {
    saveAs(blob, filename);
    console.log(`File ${filename} download initiated`);
  }
}
